"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsPageDataProvider = exports.useEventsPageDataContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const EventsDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsDataProvider");
const react_router_dom_1 = require("react-router-dom");
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const react_dom_1 = require("react-dom");
const EventsPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageModelProvider");
const CompositeChartJSONModel_1 = require("src/hello_assets/src/components/model/compositeChart/CompositeChartJSONModel");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const EventsPageDataContext = React.createContext(undefined);
const useEventsPageDataContext = () => {
    const context = React.useContext(EventsPageDataContext);
    if (!context) {
        throw new Error("useEventsPageDataContext must be used within a EventsPageDataContext.Provider");
    }
    return context;
};
exports.useEventsPageDataContext = useEventsPageDataContext;
const TEMP_FN = () => null;
const EventsPageDataProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const eventsContext = (0, EventsDataProvider_1.useEventsDataContext)();
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [state, setState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), lodash_1.default.cloneDeep(DataProviderCommonTypes_1.initialDataProviderCommonState));
    const [urlState, setURLState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), (0, EventsPageModelProvider_1.deserializeCompositeChartJSONModelFromQueryString)(location.search).serialize());
    const serializedStateData = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        const compositeChartJSONModelFromURL = (0, EventsPageModelProvider_1.deserializeCompositeChartJSONModelFromQueryString)(location.search);
        const serializedState = compositeChartJSONModelFromURL.serialize();
        const serializedStateChart = serializedState.chart;
        serializedState.chart = undefined;
        return {
            serializedState: serializedState,
            serializedStateChart: serializedStateChart
        };
    }, [location.search, TEMP_FN], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Change URL state only when ChartSettings changes.
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        const compositeChartJSONModel = (0, EventsPageModelProvider_1.deserializeCompositeChartJSONModelFromQueryString)(location.search);
        setURLState(compositeChartJSONModel.serialize());
    }, [projectApiKey, serializedStateData.serializedStateChart, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Fetch data on page URL state change (!!! IMPORTANT: without ChartSettings !!!)
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        if (isMounted()) {
            (async () => {
                const compositeChartJSONModel = (0, EventsPageModelProvider_1.deserializeCompositeChartJSONModelFromQueryString)(location.search);
                const queryEventVariants = compositeChartJSONModel.getEventsJSONModel().getQueryEventVariantArray();
                const lastNDays = compositeChartJSONModel.getPeriodDaysJSONModel().getLast();
                const aggregation = compositeChartJSONModel.getCompositeChartAggregationJSONModel().getAggregation();
                (0, react_dom_1.unstable_batchedUpdates)(() => {
                    setState({ inProgress: true });
                });
                const newDataState = {};
                try {
                    // if (process.env.NODE_ENV === "development") {
                    //     await delayPromise(2000)
                    // }
                    const queryEventVariantsEmpty = lodash_1.default.isEmpty(queryEventVariants);
                    // console.log("eventNamesEmpty", eventNamesEmpty);
                    const eventsUniques = queryEventVariantsEmpty ? undefined : await eventsContext.fetchEventUniques(queryEventVariants, lastNDays, aggregation);
                    newDataState.error = undefined;
                    newDataState.isError = false;
                    newDataState.data = eventsUniques;
                }
                catch (e) {
                    newDataState.error = e;
                    newDataState.isError = true;
                }
                newDataState.loaded = true;
                newDataState.inProgress = false;
                (0, react_dom_1.unstable_batchedUpdates)(() => {
                    setURLState(compositeChartJSONModel.serialize());
                    setState(newDataState);
                });
            })();
        }
    }, [projectApiKey, serializedStateData.serializedState, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Get URL JSON Model
    ////////////////////////////////////////////////
    const getURLJSONModel = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        return new CompositeChartJSONModel_1.CompositeChartJSONModel(urlState);
    }, [urlState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Chart Settings Changed
    ////////////////////////////////////////////////
    const onChartSettingsChanged = (0, use_custom_compare_1.useCustomCompareCallback)((chartSettings) => {
        const compositeChartJSONModel = new CompositeChartJSONModel_1.CompositeChartJSONModel(urlState);
        compositeChartJSONModel.getChartSettingsJSONModel().overwriteFromSerializedState(chartSettings);
        const serializedState = compositeChartJSONModel.serialize();
        const newUrl = AppRouting_1.AppPathGenerator.Project.events(projectApiKey, serializedState);
        history.push(newUrl);
    }, [urlState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Return value
    ////////////////////////////////////////////////
    const stateFns = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        getURLJSONModel,
        onChartSettingsChanged,
    }), [
        getURLJSONModel,
        onChartSettingsChanged,
    ], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        state,
        urlState,
        stateFns,
    }), [
        state,
        urlState,
        stateFns,
    ], lodash_1.default.isEqual);
    return React.createElement(EventsPageDataContext.Provider, { value: value }, props.children);
};
exports.EventsPageDataProvider = EventsPageDataProvider;
